import React, { createContext, useContext, useState, useEffect } from 'react';
import toast from 'react-hot-toast';

const CompareContext = createContext();

export const useCompare = () => useContext(CompareContext);

export const CompareProvider = ({ children }) => {
    const [comparedProducts, setComparedProducts] = useState(() => {
        try {
            const saved = localStorage.getItem('comparedProducts');
            return saved ? JSON.parse(saved) : [];
        } catch (error) {
            console.error('Failed to load compared products', error);
            return [];
        }
    });

    useEffect(() => {
        try {
            localStorage.setItem('comparedProducts', JSON.stringify(comparedProducts));
        } catch (error) {
            console.error('Failed to save compared products', error);
        }
    }, [comparedProducts]);

    const addToCompare = (product) => {
        setComparedProducts((prev) => {
            if (prev.find((p) => String(p.id) === String(product.id))) return prev;
            if (prev.length >= 6) {
                toast.error('You can compare up to 6 products at a time.');
                return prev;
            }
            return [...prev, product];
        });
    };

    const removeFromCompare = (productId) => {
        setComparedProducts((prev) => prev.filter((p) => String(p.id) !== String(productId)));
    };

    const isInCompare = (productId) => {
        return comparedProducts.some((p) => String(p.id) === String(productId));
    };

    const clearCompare = () => {
        setComparedProducts([]);
    };

    return (
        <CompareContext.Provider value={{ comparedProducts, addToCompare, removeFromCompare, isInCompare, clearCompare }}>
            {children}
        </CompareContext.Provider>
    );
};
